module.exports = __webpack_public_path__ + "media/src/assets/Images/LoginBackground-a7c6bfc70ac2a210fa411906724562ba.svg";